<div class="carousel-container">
  <p class="titleCarousel">الأخبار و الأحداث</p>

  <ngx-slick-carousel class="carousel" [config]="sliderConfig">
    <div ngxSlickItem *ngFor="let project of projects">
      <div class="carousel-inner shadow mainDivOfRow mb-3">
        <div class="row g-0 align-items-stretch h-100">

          <!-- Image Section -->
          <div class="col-12 col-md-5 imageDiv">
            <img [src]="project.solutionImage" [alt]="project.solutionTitle" />
          </div>

          <!-- Content Section -->
          <div class="col-12 col-md-7 contentDiv">
            <p class="bgNewsGray text-center p-2">الأخبار</p>
            <p class="dateStyle">{{ project.date }}</p>
            <h3 class="fontStyle">{{ project.solutionTitle }}</h3>
            <div class="hrDiv"></div>
            <p class="py-3 fontSize">{{ project.solutionDesc }}</p>

            <div class="btnGreen d-flex align-items-center justify-content-center mt-auto">
              <a class="afontStyle" [href]="project.solutionLink" target="_blank">
                إقرأ المزيد
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  </ngx-slick-carousel>
</div>